import { render } from "./ModalUnitRemove.vue?vue&type=template&id=f354711a"
import script from "./ModalUnitRemove.vue?vue&type=script&lang=js"
export * from "./ModalUnitRemove.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__